import { useEffect } from 'react';
import { HashRouter as Router, Route, Routes, useLocation, Navigate } from 'react-router-dom';

import LayoutPC from '../pages/layout/pc';
import HomePC from '../pages/home/pc';
import DigitPC from '../pages/project/digit/pc';
import SummitDetailPC from '../pages/project/digit/pc/summitDetail';
import CityPC from '../pages/project/city/pc';
import CommitteePC from '../pages/project/committee/pc';
import WorkPC from '../pages/project/work/pc';
import SciencePC from '../pages/project/science/pc';
import LocalPC from '../pages/project/local/pc';
import TourPC from '../pages/project/tour/pc';
import TalentsPC from '../pages/project/talents/pc';
import ApplicationFormPC from '../pages/project/service/pc/applicationForm';
import NewsListPC from '../pages/news/pc/list';
import NewsDetailPC from '../pages/news/pc/detail';
import MemberPC from '../pages/member/pc';
import StandardMorePC from '../pages/member/pc/more';
import AboutPC from '../pages/about/pc';
import InstitutionPC from '../pages/about/pc/institution';

import LayoutMD from '../pages/layout/mobile';
import HomeMD from '../pages/home/mobile';
import DigitMD from '../pages/project/digit/mobile';
import InterviewListMD from '../pages/project/digit/mobile/InterviewList';
import InterviewMD from '../pages/project/digit/mobile/Interview';
import SummitDetailMD from '../pages/project/digit/mobile/summitDetail';
import WorkMD from '../pages/project/work/mobile';
import CityMD from '../pages/project/city/mobile';
import CommitteeMD from '../pages/project/committee/mobile';
import ServiceMD from '../pages/project/service/mobile';
import ScienceMD from '../pages/project/science/mobile';
import LocalMD from '../pages/project/local/mobile';
import TourMD from '../pages/project/tour/mobile';
import TalentsMD from '../pages/project/talents/mobile';
import ApplicationFormMD from '../pages/project/service/mobile/applicationForm';
import NewsListMD from '../pages/news/mobile/list';
import NewsDetailMD from '../pages/news/mobile/detail';
import MemberMD from '../pages/member/mobile';
import StandardMoreMD from '../pages/member/mobile/more';
import AboutMD from '../pages/about/mobile';
import InstitutionMD from '../pages/about/mobile/institution';

// 路由切换，将页面返回顶部
function ScrollToTop(props) {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return props.children;
}
// 路由嵌套层数不超过3层
const routes = [
  {
    path: '/',
    element: <LayoutPC />,
    children: [
      { index: true, element: <Navigate to="/home" /> },
      { path: 'home', element: <HomePC /> },
      {
        path: 'project',
        children: [
          { name: '数字新浙商', path: 'digit', index: true, element: <DigitPC /> },
          { name: '数字新浙商年度峰会', path: 'summit', element: <SummitDetailPC /> },
          { name: '科普工作', path: 'science', element: <SciencePC /> },
          { name: '杭海数字新城', path: 'city', element: <CityPC /> },
          { name: '数委会', path: 'committee', element: <CommitteePC /> },
          { name: '数字文旅', path: 'tour', element: <TourPC /> },
          { name: '数字人才', path: 'talents', element: <TalentsPC /> },
          { name: '地方服务', path: 'local', element: <LocalPC /> },
          { name: '杭海数字新城', path: 'city', element: <CityPC /> },
          { name: '标准化工作', path: 'work', element: <WorkPC /> },
          { name: '讲师申请', path: 'application', element: <ApplicationFormPC /> },
        ],
      },
      {
        path: 'news',
        children: [
          { index: true, element: <NewsListPC /> },
          { path: '/news', element: <NewsListPC /> },
          { path: 'detail', element: <NewsDetailPC /> },
        ],
      },
      {
        path: 'member',
        children: [
          { index: true, element: <MemberPC /> },
          { path: 'more', element: <StandardMorePC /> },
        ],
      },
      {
        path: 'about',
        children: [
          { index: true, element: <AboutPC /> },
          { path: 'institution', element: <InstitutionPC /> },
        ],
      },
    ],
  },
  {
    path: 'phone',
    element: <LayoutMD />,
    children: [
      { index: true, element: <Navigate to="/phone/home" /> },
      { path: 'home', element: <HomeMD /> },
      {
        path: 'project',
        children: [
          { index: true, element: <DigitMD /> },
          {
            path: 'digit',
            children: [
              { index: true, element: <DigitMD /> },
              { path: 'list', element: <InterviewListMD /> },
              { path: 'interview', element: <InterviewMD /> },
              { path: 'summit', element: <SummitDetailMD /> },
            ],
          },
          { path: 'work', element: <WorkMD /> },
          { path: 'city', element: <CityMD /> },
          { name: '科普工作', path: 'science', element: <ScienceMD /> },
          {
            path: 'service',
            children: [
              { index: true, element: <ServiceMD /> },
              { path: 'application', element: <ApplicationFormMD /> },
            ],
          },
          { name: '数委会', path: 'committee', element: <CommitteeMD /> },
          { name: '数字文旅', path: 'tour', element: <TourMD /> },
          { name: '数字人才', path: 'talents', element: <TalentsMD /> },
          { name: '地方服务', path: 'local', element: <LocalMD /> },
          { name: '杭海数字新城', path: 'city', element: <CityMD /> },
          { name: '标准化工作', path: 'work', element: <WorkMD /> },
          { name: '讲师申请', path: 'application', element: <ApplicationFormMD /> },
        ],
      },
      {
        path: 'news',
        children: [
          { index: true, element: <NewsListMD /> },
          { path: 'detail', element: <NewsDetailMD /> },
        ],
      },
      {
        path: 'member',
        children: [
          { index: true, element: <MemberMD /> },
          { path: 'more', element: <StandardMoreMD /> },
        ],
      },
      {
        path: 'about',
        children: [
          { index: true, element: <AboutMD /> },
          { path: 'institution', element: <InstitutionMD /> },
        ],
      },
    ],
  },
];

const BasicRoute = () => (
  <Router>
    <ScrollToTop>
      <Routes>
        {routes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element}>
            {route.children?.map((child, childIndex) => (
              <Route
                key={childIndex}
                path={child.path}
                element={child.element}
                index={child?.index as false | undefined}
              >
                {child.children?.map((subChild, subChildIndex) => (
                  <Route
                    key={subChildIndex}
                    path={subChild.path}
                    element={subChild.element}
                    index={subChild?.index as false | undefined}
                  >
                    {subChild.children?.map((subSubChild, subSubChildIndex) => (
                      <Route
                        key={subSubChildIndex}
                        path={subSubChild.path}
                        element={subSubChild.element}
                        index={subSubChild?.index as false | undefined}
                      />
                    ))}
                  </Route>
                ))}
              </Route>
            ))}
          </Route>
        ))}
        <Route path="*" element={<Navigate to="/home" />} />
      </Routes>
    </ScrollToTop>
  </Router>
);

export default BasicRoute;
